// extracted by mini-css-extract-plugin
export default {"headerBox":"g6a4FcKBmB1yLvSFVgjU"};